import React from 'react';
//import classes from './WizardButtonList.css';
import WizardButton from './WizardButton';
import WizardButtonWithSubtitle from './WizardButtonWithSubtitle';
import Aux from '../../hoc/Aux';

import { useTranslation } from 'react-i18next';

const wizardButtonList = (props) => {

  const { t } = useTranslation();



  if (props.withSubtitle === true){

    const title = (token) => { return  t('wizard.steps.' + props.stepName + '.values.' + token + '.title.long') }
    const subtitle = (token) => {
      return (props.withSubtitle === true)? t('wizard.steps.' + props.stepName + '.values.' + token + '.subtitle.long') : null;
    }

    return (
      <Aux>
        { props.buttons.map( (x, index) => <WizardButtonWithSubtitle
          indexValue={index}
          key={x}
          value={x}
          title={title(x)}
          subtitle={subtitle(x)}
          onClick={props.onClick}
          dividerEnabled={props.dividerEnabled}
          /> ) }
      </Aux>
    )
  } else {

    const title = (token) => { return  t('wizard.steps.' + props.stepName + '.values.' + token + '.long') }

    return (
      <Aux>
        { props.buttons.map( (x, index) => <WizardButton
          indexValue={index}
          key={x}
          value={x}
          title={title(x)}
          onClick={props.onClick}
          dividerEnabled={props.dividerEnabled}
          /> ) }
      </Aux>
    )
  }

};

export default wizardButtonList;



// WEBPACK FOOTER //
// ./src/components/Wizard/WizardButtonList.js